export default "__VITE_ASSET__HvnHDrTA__"